import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getApp } from 'firebase/app';
import { deleteUser, getAuth, signOut } from 'firebase/auth';
import { doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { AdminService } from './admin.service';
import { AuthenticationService } from './authentication.service';
import { OrganizationService } from './organization.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class HopeUserVerificationService {
  private app = getApp();
  private auth = getAuth(this.app);
  constructor(private authService: AuthenticationService, private router: Router, private userService: UserService,
    private orgService: OrganizationService, private adminService: AdminService) {
  }

  private saveUser(): void {
    const userToSave = this.auth.currentUser;
    if (userToSave == null) {
      console.log("Error in saving user: no current user.");
      return;
    }
    if (userToSave.email == null) {
      console.log("Error in saving user: current user has no email.");
      return;
    }
    const emailParts: string[] = userToSave.email?.split("@");
    const userData = doc(getFirestore(getApp()), "users", emailParts[0]);
    this.userService.setUser(emailParts[0]);
    this.orgService.setOrg(emailParts[0]);
    const name = userToSave.displayName;
    setDoc(userData, { userName: name });
  }

  public async verifyIsHopeAccount() {
    const potentialHopie = this.auth.currentUser;
    if (potentialHopie == null) {
      console.log("Error in verifying hope account: no stored user.");
      return;
    }
    if (potentialHopie.email == null) {
      console.log("Error in verifying user: user has no email.");
      return;
    }
    const emailParts = potentialHopie.email.split("@");
    if (emailParts[1] == "hope.edu") {
      this.userService.checkIfUser(potentialHopie.email);
      this.orgService.checkIfOrg(potentialHopie.email);
      this.adminService.checkIfAdmin(potentialHopie.email);

      const docuserRef = doc(getFirestore(getApp()), "users", emailParts[0]);
      const docorgRef = doc(getFirestore(getApp()), "Organizations", emailParts[0]);

      const docSnap = await getDoc(docuserRef);
      const docOrgSnap = await getDoc(docorgRef);
      if (docSnap.exists()) {
        this.authService.setSignedIn(true);
        this.router.navigate(['/homepage']);
        this.userService.setUser(emailParts[0]);
      } else if (docOrgSnap.exists()) {
        this.authService.setSignedIn(true);
        this.router.navigate(['/homepage']);
        this.orgService.setOrg(emailParts[0]);
      } else {
        this.saveUser();
        this.authService.setSignedIn(true);
        this.router.navigate(['/createuser']);
      }
    }
    else {
      this.authService.setSignedIn(false);
      deleteUser(potentialHopie);
      signOut(this.auth);
      this.router.navigate(["/login"]);
    }
  }
}
